export class Navigation {
	constructor() {
		this.open = false
		this.toggle = document.querySelectorAll('[data-toggle-nav]')

		this.toggle.forEach((button) => {
			button.addEventListener('click', () => {
				this.open ? this.closeNavigation() : this.openNavigation()
			})
		})

		this.setActiveState()
	}
	openNavigation() {
		this.open = true
		document.documentElement.classList.add('nav-open')
	}
	closeNavigation() {
		this.open = false
		document.documentElement.classList.remove('nav-open')
	}
	setActiveState() {

    const url = window.location.href
    const menuItems = document.querySelectorAll('.menu-item a')

    menuItems.forEach(item => {
      item.parentElement.classList.remove('current-menu-item')
      if (item.href == url) {
        item.parentElement.classList.add('current-menu-item')
      }
    })
  }
	snapCloseNavigation() {}
}

export default () => {}